export default __webpack_public_path__ + "static/media/0075.99161597.jpg";